'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  category: null,
  operation: null,
  affectedChannels: [],
  subscribedChannels: [],
  affectedChannelGroups: [],
  lastTimetoken: null,
  currentTimetoken: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/PubNubStatusRecord.js
// module id = 530
// module chunks = 0